import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/documents/download', request)
}

export {get}
